module.exports = __webpack_public_path__ + "static/img/logomini.a7312586.png";